import React from "react";
import { useMedia } from "react-media";

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
  // medium: "(min-width: 600px) and (max-width: 1199px)",
  large: "(min-width: 991px)",
  smallSpace: "(max-width: 1380px)",
};

const ResponsiveItemsWrapper = (props) => {
  const { children, isSmall } = props;
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  const direction =
    isSmall && matches.smallSpace ? "column" : matches.large ? "row" : "column";
  return (
    <div style={{ display: "flex", flexDirection: direction }}>{children}</div>
  );
};

export default ResponsiveItemsWrapper;
